import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enTranslations from './translations/en'
import { CURRENCIES, SUPPORTED_LANGUAGES } from '../constants/app'

const supportedLanguages = SUPPORTED_LANGUAGES

i18n.use(initReactI18next).init({
  fallbackLng: supportedLanguages[0],
  supportedLngs: supportedLanguages,
  whitelist: supportedLanguages,
  debug: false,
  interpolation: {
    defaultVariables: {
      qbxCurrency: CURRENCIES.QBX,
      ethCurrency: CURRENCIES.DEFAULT,
      virCurrency: CURRENCIES.VIR
    },
    escapeValue: false
  },
  resources: {
    en: {
      translation: enTranslations
    }
  }
})

export default i18n
